import { useState, useEffect } from 'react';

export default function Tablet(props: { children: any }) {
  const [showChild, setShowChild] = useState(false);

  useEffect(() => {
    showOnDesktop();
    window.addEventListener('resize', showOnDesktop, { passive: true });
    return () => {
      window.removeEventListener('resize', showOnDesktop);
    };
  }, []);

  function showOnDesktop() {
    if (window.innerWidth <= 768) {
      setShowChild(true);
    } else {
      setShowChild(false);
    }
  }

  if (showChild) {
    return props.children;
  }

  return null;
}
